module.exports = __webpack_public_path__ + "img/hr-concrete-hole-decal-07.7b61c448.png";